import axios from 'axios';

export default axios.create({ baseURL: 'https://api.techm.co.in/api/' });
